import { SearchHistory } from "../types/search";

export async function fetchHistory(token: string): Promise<SearchHistory[]> {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/history/websites`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) throw new Error("Failed to fetch history");
  const data = await res.json();

  // defensive return
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.history)) return data.history;
  if (Array.isArray(data.data)) return data.data;
  return [];
}
